import { createI18n } from 'vue-i18n'
import ru from '@/assets/translations/ru.json'
import kz from '@/assets/translations/kz.json'

/**
 * Языки шлюза — те же, что у Novator: `ru` и `kz` (ключ в localStorage — `locale`, как во
 * frontend-js). Отдельным модулем, а не внутри main.js: translateIfKey и сторы переводят вне
 * компонентов.
 */
export const LOCALES = ['ru', 'kz']
const STORAGE_KEY = 'locale'

function storedLocale() {
  try {
    const value = localStorage.getItem(STORAGE_KEY)
    return LOCALES.includes(value) ? value : 'ru'
  } catch {
    return 'ru'
  }
}

const i18n = createI18n({
  locale: storedLocale(),
  legacy: false,
  fallbackLocale: 'ru',
  messages: { ru, kz },
})

// `lang` страницы — для экранных дикторов и переносов; у казахского код ISO — `kk`.
function applyDocumentLang(locale) {
  document.documentElement.lang = locale === 'kz' ? 'kk' : 'ru'
}
applyDocumentLang(i18n.global.locale.value)

export function setLocale(locale) {
  if (!LOCALES.includes(locale)) return
  i18n.global.locale.value = locale
  applyDocumentLang(locale)
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch {
    // Хранилище недоступно (приватный режим) — язык просто не запомнится.
  }
}

export default i18n
